<template>
    <div class="c-default-overlay is-active">
        <button class="close-button c-overlay-close-button" aria-label="Close alert" type="button" v-on:click.prevent="close">
            <span aria-hidden="true">&times;</span>
        </button>
        <div class="c-default-overlay-wrapper">
            <h2 class="c-heading-large" v-if="usp.overlay_title">{{ usp.overlay_title }}</h2> 
            <img v-if="usp.article_image" :src="changeImageSize(usp.article_image.media_path, 550, '_')" :alt="usp.article_image.media_title">  
            <p class="u-margin-top-medium" v-if="usp.overlay_description" v-html="usp.overlay_description"></p> 
        </div>
    </div>
</template>
<script>
    export default {
        name: 'usp-popup',
        props: ['usp'],
        data() {
            return {

            }
        },
        mounted() {
            this.disableScroll();
        },
        beforeDestroy() {
            this.disableScroll();
        },
        methods: {
            /**
             * Close the popup
             *
             * @author Rick van der Burg <rick@click.nl>
             * @return void
             */
            close() {
                this.$emit('close');
            },
            /**
             * Disables the scroll for the body when overlay is open
             *
             * @author Yonita van Oudheusden <yonita@click.nl>
             * @return void
             */
            disableScroll() {
                var $body = $('body');
                // Add class that will disable the scroll on the body 

                if($body.hasClass('u-disable-scroll')) {
                    $body.removeClass('u-disable-scroll');
                } else {
                    $body.addClass('u-disable-scroll');
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/frontend/vue/components/usps/usp-popup.vue